const sinAcentos = (texto) => String(texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '')

const valorDeComponente = (componentes, tipo, { corto = false } = {}) => {
    const encontrado = (componentes || []).find(item => (item?.types || []).includes(tipo))
    if (!encontrado) return ''
    return (corto ? encontrado.shortText : encontrado.longText) || ''
}

const coordenada = (ubicacion, eje) => {
    if (!ubicacion) return null
    const valor = typeof ubicacion[eje] === 'function' ? ubicacion[eje]() : ubicacion[eje]
    return Number.isFinite(valor) ? valor : null
}

export const datosDesdeLugar = (lugar) => {
    const componentes = lugar?.addressComponents || []
    const calle = valorDeComponente(componentes, 'route')
    const altura = valorDeComponente(componentes, 'street_number')
    const codigoPostal = valorDeComponente(componentes, 'postal_code', { corto: true })

    return {
        direccion: [calle, altura].filter(Boolean).join(' '),
        localidad: valorDeComponente(componentes, 'locality')
            || valorDeComponente(componentes, 'sublocality_level_1')
            || valorDeComponente(componentes, 'administrative_area_level_2'),
        cod_postal: (codigoPostal.match(/\d{4}/) || [''])[0],
        provincia: valorDeComponente(componentes, 'administrative_area_level_1'),
        partido: valorDeComponente(componentes, 'administrative_area_level_2'),
        place_id: lugar?.id || null,
        latitud: coordenada(lugar?.location, 'lat'),
        longitud: coordenada(lugar?.location, 'lng'),
        tipos: Array.isArray(lugar?.types) ? lugar.types : []
    }
}

const normalizarNombre = (texto) => sinAcentos(texto)
    .toLowerCase()
    .replace(/^provincia de\s+/, '')
    .replace(/[()]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

export const buscarProvincia = (provincias, provinciaGoogle, partidoGoogle) => {
    const provincia = normalizarNombre(provinciaGoogle)
    const partido = normalizarNombre(partidoGoogle)
    if (!provincia) return null

    const lista = Array.isArray(provincias) ? provincias : []

    if (partido) {
        const conPartido = lista.filter(item => normalizarNombre(item.nombre) === `${provincia} ${partido}`)
        if (conPartido.length === 1) return conPartido[0].id_provincia
    }

    const soloProvincia = lista.filter(item => normalizarNombre(item.nombre) === provincia)
    return soloProvincia.length === 1 ? soloProvincia[0].id_provincia : null
}

export const lugarParaGuardar = (datos) => {
    if (!datos?.place_id || !Number.isFinite(datos.latitud) || !Number.isFinite(datos.longitud)) return null
    return { place_id: datos.place_id, latitud: datos.latitud, longitud: datos.longitud, tipos: datos.tipos || [] }
}
